"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toc = exports.title = exports.slug = exports.position = exports.pageId = exports.navTitle = exports.name = exports.metaDescription = exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("@mdx-js/react");
/*@jsxRuntime automatic @jsxImportSource react*/
// translate-ignore

const pageId = exports.pageId = 29907021628;
const slug = exports.slug = 'guides/apps/authentication/working-with-oauth';
// translate-ignore
const navTitle = exports.navTitle = 'Working with OAuth';
const title = exports.title = 'Working with OAuth';
const name = exports.name = 'vNext Docs DP - Working with OAuth';
const metaDescription = exports.metaDescription = 'OAuth is a secure means of authentication for your app. It uses authorization tokens rather than a password to connect your app to a user account. ';
const position = exports.position = 3;
const toc = exports.toc = [{
  "depth": 0,
  "id": "recommended-resources",
  "label": "Recommended resources",
  "parent": null
}, {
  "depth": 0,
  "id": "set-up-oauth-authentication",
  "label": "Set up OAuth authentication",
  "parent": null
}, {
  "depth": 0,
  "id": "query-parameters",
  "label": "Query parameters",
  "parent": null
}, {
  "depth": 0,
  "id": "configure-scopes",
  "label": "Configure scopes",
  "parent": null
}, {
  "depth": 0,
  "id": "related-docs",
  "label": "Related docs",
  "parent": null
}];
function _createMdxContent(props) {
  const _components = Object.assign({
      h1: "h1",
      p: "p",
      a: "a",
      ul: "ul",
      li: "li",
      h2: "h2",
      em: "em",
      img: "img",
      code: "code",
      strong: "strong",
      table: "table",
      thead: "thead",
      tr: "tr",
      th: "th",
      tbody: "tbody",
      td: "td"
    }, (0, _react.useMDXComponents)(), props.components),
    {
      Alert
    } = _components;
  if (!Alert) _missingMdxReference("Alert", true);
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsx)(_components.h1, {
      children: "Working with OAuth"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["OAuth is a secure means of authentication that uses authorization tokens rather than a password to connect your app to a user account. Initiating OAuth access is the first step towards allowing users to ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/guides/apps/public-apps/overview#install-an-app",
        children: "install your app"
      }), " in their HubSpot accounts."]
    }), "\n", (0, _jsxRuntime.jsx)(Alert, {
      type: "warning",
      titleText: "Please note:",
      children: (0, _jsxRuntime.jsxs)(_components.ul, {
        children: ["\n", (0, _jsxRuntime.jsx)(_components.li, {
          children: "Any app designed for installation by multiple HubSpot accounts or listing on the App Marketplace must use OAuth."
        }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
          children: ["Users installing apps in their HubSpot account must either be a ", (0, _jsxRuntime.jsx)(_components.a, {
            href: "https://knowledge.hubspot.com/user-management/hubspot-user-permissions-guide#super-admin",
            children: "Super Admin"
          }), " or have ", (0, _jsxRuntime.jsx)(_components.a, {
            href: "https://knowledge.hubspot.com/user-management/hubspot-user-permissions-guide#settings",
            children: "App Marketplace Access"
          }), " permissions."]
        }), "\n"]
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Recommended resources"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["The ", (0, _jsxRuntime.jsx)(_components.a, {
          href: "/guides/apps/authentication/oauth-quickstart-guide",
          children: "OAuth Quickstart Guide"
        }), " will get you up and running with a working example app."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["This ", (0, _jsxRuntime.jsx)(_components.a, {
          href: "https://app.hubspot.com/l/academy/tracks/71/593/2967",
          children: "HubSpot Academy tutorial"
        }), " provides a quick introduction on using OAuth with HubSpot, including a breakdown of the HubSpot-OAuth flow and how to refresh an access token."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Set up OAuth authentication"
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "To set up OAuth authentication for your app:"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["First, ", (0, _jsxRuntime.jsx)(_components.a, {
          href: "/guides/apps/public-apps/overview",
          children: "create an app"
        }), " in a ", (0, _jsxRuntime.jsx)(_components.a, {
          href: "/getting-started/account-types#developer-accounts",
          children: "HubSpot developer account"
        }), ". After creating the app, you'll be able to find the app's client ID and client secret on the ", (0, _jsxRuntime.jsx)(_components.em, {
          children: "Auth"
        }), " page of your app settings."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: (0, _jsxRuntime.jsx)(_components.img, {
        src: "https://cdn2.hubspot.net/hubfs/53/MyHubSpotApp.png",
        alt: "MyHubSpotApp"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["\n", (0, _jsxRuntime.jsxs)(_components.p, {
          children: ["Use the client ID and client secret, along with the ", (0, _jsxRuntime.jsx)(_components.a, {
            href: "#query-parameters",
            children: "query parameters"
          }), " and ", (0, _jsxRuntime.jsx)(_components.a, {
            href: "#scopes",
            children: "scopes"
          }), " outlined below, to build your authorization URL."]
        }), "\n"]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["\n", (0, _jsxRuntime.jsxs)(_components.p, {
          children: ["Send users installing your app to the authorization URL, where they'll be presented with a screen that allows them to select their account and grant access to your integration. You can set the authorization URL to be for a specific HubSpot account by adding the account ID between ", (0, _jsxRuntime.jsx)(_components.code, {
            children: "/oauth/"
          }), " and ", (0, _jsxRuntime.jsx)(_components.code, {
            children: "/authorize"
          }), ", as shown below. After granting access, they'll be redirected back to your application via a ", (0, _jsxRuntime.jsx)(_components.code, {
            children: "redirect_url"
          }), ", which will have a code query parameter appended to it. You'll use that code and the client secret to get an ", (0, _jsxRuntime.jsx)(_components.a, {
            href: "/guides/api/app-management/oauth-tokens",
            children: "access_token and refresh_token"
          }), " from HubSpot."]
        }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
          children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
            children: [(0, _jsxRuntime.jsx)(_components.strong, {
              children: "Example authorization URLs"
            }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
              children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
                children: [(0, _jsxRuntime.jsx)(_components.strong, {
                  children: "Any account:"
                }), " ", (0, _jsxRuntime.jsx)(_components.code, {
                  children: "https://app.hubspot.com/oauth/authorize?client_id=xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx&scope=contacts%20automation&redirect_uri=https://www.example.com/"
                })]
              }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
                children: [(0, _jsxRuntime.jsx)(_components.strong, {
                  children: "Specific account (ID 123456):"
                }), " ", (0, _jsxRuntime.jsx)(_components.code, {
                  children: "https://app.hubspot.com/oauth/123456/authorize?client_id=xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx&scope=contacts%20automation&redirect_uri=https://www.example.com/"
                })]
              }), "\n"]
            }), "\n"]
          }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
            children: [(0, _jsxRuntime.jsx)(_components.strong, {
              children: "Example redirect URL:"
            }), " ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "https://example.com/?code=xxxx"
            })]
          }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
            children: [(0, _jsxRuntime.jsx)(_components.strong, {
              children: "Example error:"
            }), " ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "https://www.example.com/?error=error_code&error_description=Human%20readable%20description%20of%20the%20error"
            })]
          }), "\n"]
        }), "\n"]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["\n", (0, _jsxRuntime.jsxs)(_components.p, {
          children: ["Use the ", (0, _jsxRuntime.jsx)(_components.code, {
            children: "access_token"
          }), " to authenticate any API calls made for that HubSpot account."]
        }), "\n"]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: ["\n", (0, _jsxRuntime.jsxs)(_components.p, {
          children: ["Once the ", (0, _jsxRuntime.jsx)(_components.code, {
            children: "access_token"
          }), " expires, use the ", (0, _jsxRuntime.jsx)(_components.code, {
            children: "refresh_token"
          }), " to generate a new ", (0, _jsxRuntime.jsx)(_components.code, {
            children: "access_token"
          }), "."]
        }), "\n"]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(Alert, {
      type: "warning",
      titleText: "Please note:",
      children: (0, _jsxRuntime.jsxs)(_components.ul, {
        children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
          children: ["Your app will not appear as a ", (0, _jsxRuntime.jsx)(_components.em, {
            children: "Connected App"
          }), " in a user's account unless you generate the refresh token and initial access token."]
        }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
          children: ["Access tokens reflect the scopes requested from the app and ", (0, _jsxRuntime.jsx)("u", {
            children: "do not"
          }), " reflect the permissions or limitations of what a user can do in their HubSpot account. For example, if a user has permissions to view only owned contacts but authorizes a request for the ", (0, _jsxRuntime.jsx)(_components.code, {
            children: "crm.objects.contacts.read"
          }), " scope, the resulting access token can view all contacts in the account and not only those owned by the authorizing user."]
        }), "\n"]
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Query parameters"
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "The following query parameters are required when building an authorization URL for your app:"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.table, {
      children: [(0, _jsxRuntime.jsx)(_components.thead, {
        children: (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.th, {
            children: (0, _jsxRuntime.jsx)(_components.strong, {
              children: "Parameter"
            })
          }), (0, _jsxRuntime.jsx)(_components.th, {
            children: (0, _jsxRuntime.jsx)(_components.strong, {
              children: "Description"
            })
          }), (0, _jsxRuntime.jsx)(_components.th, {
            children: (0, _jsxRuntime.jsx)(_components.strong, {
              children: "How to use"
            })
          })]
        })
      }), (0, _jsxRuntime.jsxs)(_components.tbody, {
        children: [(0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "client_id"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "An ID that serves as a unique identifier for your app."
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Get this from your app's Auth settings page (as described above)."
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "redirect_uri"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "The URL visitors will be redirected to after granting access to your app."
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: ["You'll also designate this on your app's Auth settings page. ", (0, _jsxRuntime.jsx)(_components.strong, {
              children: "Note:"
            }), " For security reasons, this URL ", (0, _jsxRuntime.jsx)("u", {
              children: "must"
            }), " use ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "https"
            }), " in production. (When testing using ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "localhost"
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "http"
            }), " can be used.) You also ", (0, _jsxRuntime.jsx)("u", {
              children: "must"
            }), " use a domain, as IP addresses are not supported."]
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "scope"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "A space-separated set of permissions that your app needs access to."
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: ["Any scopes that you've checked off in your app's ", (0, _jsxRuntime.jsx)(_components.em, {
              children: "Auth"
            }), " settings will be treated as required, and you'll need to include them in this parameter or the authorization page will display an error. Additionally, users will get an error if they try to install your app in an account that doesn't have access to an included scope. Consult the ", (0, _jsxRuntime.jsx)(_components.a, {
              href: "/guides/apps/authentication/scopes#list-of-available-scopes",
              children: "scopes reference documentation"
            }), " for more details about which endpoints can be accessed by specific scopes."]
          })]
        })]
      })]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "The following parameters are optional:"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.table, {
      children: [(0, _jsxRuntime.jsx)(_components.thead, {
        children: (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.th, {
            children: (0, _jsxRuntime.jsx)(_components.strong, {
              children: "Parameter"
            })
          }), (0, _jsxRuntime.jsx)(_components.th, {
            children: (0, _jsxRuntime.jsx)(_components.strong, {
              children: "How to use"
            })
          }), (0, _jsxRuntime.jsx)(_components.th, {
            children: (0, _jsxRuntime.jsx)(_components.strong, {
              children: "Description"
            })
          })]
        })
      }), (0, _jsxRuntime.jsxs)(_components.tbody, {
        children: [(0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "optional_scope"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "A space-separated set of optional permissions for your app."
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: ["Optional scopes will be automatically dropped from the authorization request if the user selects a HubSpot account that doesn't have access to that tool (e.g., authorizing a ", (0, _jsxRuntime.jsxs)(_components.em, {
              children: [(0, _jsxRuntime.jsx)(_components.strong, {
                children: "Content Hub"
              }), " Enterprise"]
            }), " scope in a HubSpot free account). If you're using optional scopes, you will need to check the access token or refresh token to see which ones were granted. Check out the ", (0, _jsxRuntime.jsx)(_components.a, {
              href: "/guides/apps/authentication/scopes",
              children: "reference documentation on scopes"
            }), " for more details."]
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "state"
            })
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: ["If this parameter is included in the authorization URL, the value will be included in a state query parameter when the user is directed to the ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "redirect_uri"
            }), "."]
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "A string value that can be used to maintain the user's state when they're redirected back to your app."
          })]
        })]
      })]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Configure scopes"
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "OAuth requires you to set scopes, or permissions, for your app. Each scope provides access to a set of HubSpot API endpoints and allows users to grant your app access to specific tools in their HubSpot account."
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: (0, _jsxRuntime.jsx)(_components.img, {
        src: "https://www.hubspot.com/hubfs/Knowledge_Base_2021/Developer/granular-scopes-selection.png",
        alt: "granular-scopes-selection"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Access to specific APIs or endpoints depends on HubSpot account tier. If your app can work with multiple types of HubSpot accounts, you can use the ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "optional_scope"
      }), " parameter to include any tiered scopes you work. This way, customers using HubSpot free accounts can still authorize your app, even if they can't access all of its scopes. Your app must check for and handle any scopes that it doesn't get authorized for."]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["A full list of scopes is available ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/guides/apps/authentication/scopes",
        children: "here"
      }), "."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Related docs"
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: (0, _jsxRuntime.jsx)(_components.a, {
        href: "/guides/apps/authentication/intro-to-auth",
        children: "Auth methods on HubSpot"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: (0, _jsxRuntime.jsx)(_components.a, {
        href: "/guides/apps/authentication/oauth-quickstart-guide",
        children: "OAuth Quickstart Guide"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: (0, _jsxRuntime.jsx)(_components.a, {
        href: "/guides/api/app-management/oauth-tokens",
        children: "Managing tokens"
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {
    wrapper: MDXLayout
  } = Object.assign({}, (0, _react.useMDXComponents)(), props.components);
  return MDXLayout ? (0, _jsxRuntime.jsx)(MDXLayout, Object.assign({}, props, {
    children: (0, _jsxRuntime.jsx)(_createMdxContent, props)
  })) : _createMdxContent(props);
}
var _default = exports.default = MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}